import { useEffect, useState } from 'react'
import { withRouter, useLocation } from "react-router";
import { PAGES, ROUTE_PATHS } from '../InternalApiApp';
import { BarChart2, User, BookOpen, Settings, HelpCircle } from 'react-feather';
import SidebarExtensionWrapper from '../components/SideBar/SideBarExtension/SideBarExtensionWrapper';
import SideBarLeft from '../components/SideBar/SideBarLeft';
import TopBar from '../components/TopBar/TopBar';
import TopBannerExtension from './Shared/Banner/TopBannerExtension'
import useWindowDimensions, { pluralise, useStorage, withStorage } from '../Utils/Utils';
import ActiveWorkFlowIcon from '../images/icons/ActiveWorkflowIcon'
import LoadingIcon from '../components/LoadingIcon';
import defaultAnalyticsConfig from "./Analytics/AnalyticsPortfolioLayout.json"
import "./MenuWrapper.scss";


const MenuWrapper = (props) => {
	let [sideBarExtensionLeft, setSideBarExtensionLeft] = useState(true)
	let [sidebarExtLeftHeader, setSidebarExtLeftHeader] = useState({})
	let [sideBarRight, setSideBarRight] = useState(false)
	let [sideBarExtensionRight, setSideBarExtensionRight] = useState("")
	let [alertBannerActive, setAlertBannerActive] = useState(false)
	let [sidebarExtLeftLinks, setSidebarExtLeftLinks] = useState([])
	let [topBarExtension, setTopBarExtension] = useState(false)
	let [topBarExtContent, setTopBarExtContent] = useState({})
	let [leftSideBarCollapsed, setLeftSideBarCollapsed] = useState(false)
	const [switchingCompany, setSwitchingCompany] = useState(false)
	const [portfolioTopBarHierarchy, setPortfolioTopBarHierarchy] = useState([]);

	// const socket = new SockJS('/ws');
	// const stompClient = Stomp.over(socket);

	// this.handleSocketMessage = this.handleSocketMessage.bind(this);
	// this.authoriseSocket = this.authoriseSocket.bind(this);


	const [topMessage, setTopMessage] = useState(null);

	const width = useWindowDimensions().width
	const location = useLocation()
	let pathArray = location.pathname.split("/")

	const { topComponent, user, noPermissions, organisation, sendMessage, isExternalManager, helpPage, helpVideos, analyticsConfig } = props;
	const jsonFile = analyticsConfig || defaultAnalyticsConfig

	// authoriseSocket(() => {
	// 	window.clientRef.sendMessage('/topics/auth', sessionStorage.getItem('3skye.auth.token'));
	// })

	const storage = useStorage()

	useEffect(() => {
		setTopMessage(topComponent);
	}, [topComponent])

	useEffect(() => {
		props.storage.watch("research-master-grid", updateGridClasses)
		return (
			props.storage.unwatch("research-master-grid")
		)
	}, [])


	useEffect(() => {
		if (user && user.perms && user.perms.includes("PORTFOLIO_MANAGEMENT")) {
			storage.getOrFetch("funds/portfolio/groupings/hierarchy").then((hierarchy) => {
				hierarchy = hierarchy.filter((item) => item.displaysInHierarchy).sort((a, b) => a.hierarchyOrder - b.hierarchyOrder).map((item) => item.groupingName);
				setPortfolioTopBarHierarchy(hierarchy)
			})
		}
	}, []);

	const updateGridClasses = (gridClass) => {
		switch (gridClass) {
			case "sideBarExtLeftActive":
				setSideBarExtensionLeft(true)
				break;
			case "sideBarExtLeftInactive":
				setSideBarExtensionLeft(false)
				break;
			case "SideBarRight":
				setSideBarRight(!sideBarRight)
				break;
			case "alertBannerActive":
				setAlertBannerActive(true)
				break;
			case "alertBannerInactive":
				setAlertBannerActive(false)
				break;
			case "sideBarExtRightActive":
				setSideBarExtensionRight('s')
				break;
			case "right-m":
				setSideBarExtensionRight('m')
				break;
			case "right-l":
				setSideBarExtensionRight('l')
				break;
			case "sideBarExtRightInactive":
				setSideBarExtensionRight('')
				break;
			case "topBarExtActive":
				setTopBarExtension(true)
				break;
			case "topBarExtInactive":
				setTopBarExtension(false)
				break;
			default:
				break;
		}
	}

	useEffect(() => {
		const path = props.location.pathname

		if (noPermissions) {
			setTopBarExtContent(null)
			setSidebarExtLeftLinks([])
			setSidebarExtLeftHeader(null)
			setTopBarExtension(false)
			setSideBarExtensionLeft(false)
			setSideBarRight(false)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
			setTopMessage(null);
		} else if (path === "/" || path.includes("delivery")) {
			setTopBarExtContent({
				header: "Library",
				icon: <BookOpen color="#0E8EFD" />,
				links: [{ name: "Library", path: "/" }],
				headerOnly: true
			})
			setSidebarExtLeftLinks([])
			setSidebarExtLeftHeader(null)
			setTopBarExtension(true)
			setSideBarExtensionLeft(false)
			setSideBarRight(false)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
			setTopMessage(null);
		}
		else if (path.includes("/editor")) {
			setTopBarExtContent(null)
			setSidebarExtLeftLinks([])
			setTopBarExtension(false)
			setSideBarExtensionLeft(true)
			setSideBarRight(true)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
		}
		else if (path.includes("/admin")) {
			if (user && user.perms && user.perms.some((val) => ["TICKERS", "MODEL_PORTFOLIOS", "ASSET_CLASS_MGT", "SECTORS", "DISCLAIMER", "USER_MANAGEMENT", "COMPANY_MANAGEMENT", "PORTFOLIO_MANAGEMENT", "ROLES", "TEMPLATES"].includes(val))) {
				setSidebarExtLeftHeader({ header: "Settings", icon: <Settings color="#0E8EFD" /> })
				if (organisation?.hasSubBrands && path.includes("brand-settings")) {
					setTopBarExtension(true)
					setTopBarExtContent({
						header: '',
						icon: null,
						links: [
							{ name: "Brand", path: "/admin/brand-settings/brand" },
							{ name: "Sub-Brands", path: "/admin/brand-settings/sub-brands" }
						]
					})
				} else if (path.includes('fund-management')) {
					setTopBarExtension(true)
					setTopBarExtContent({
						header: '',
						icon: null,
						links: [
							{ name: "Schemes", path: "/admin/fund-management/schemes" },
							{ name: "Offers", path: "/admin/fund-management/offers" },
							{ name: "Funds", path: "/admin/fund-management/funds" }
						]
					})
				} else if (path.includes('portfolio-management')) {
					setTopBarExtension(true)
					const links = [
						{ name: "Platforms", path: "/admin/portfolio-management/platforms" },
						{ name: "Products", path: "/admin/portfolio-management/products" }
					]
					portfolioTopBarHierarchy.forEach((item) => {
						const plural = pluralise(item);
						links.push({ name: plural, path: `/admin/portfolio-management/${plural.toLowerCase()}` })
					})
					links.push({ name: "Portfolios", path: "/admin/portfolio-management/portfolios" })

					setTopBarExtContent({
						header: '',
						icon: null,
						links: links
					})
	
				} else if (path.includes('external-access')) {
					setTopBarExtension(true)
					const links = [
						{ name: "Companies", path: "/admin/external-access/companies" },
						{ name: "Users", path: "/admin/external-access/users" },
						{ name: "Commentary Tracker", path: "/admin/external-access/commentary-tracker" }
					]
					setTopBarExtContent({
						header: '',
						icon: null,
						links: links
					})
				} else {
					setTopBarExtContent(null)
					setTopBarExtension(false)
				}
				setSidebarExtLeftLinks([
					{ name: "Analytics Config", path: "/admin/analytics-config", requires: "ANALYTICS_VIEW", group: "Admin" },
					{ name: "Asset Class Management", path: "/admin/asset-class", requires: "ASSET_CLASS_MGT", group: "Product Config" },
					{ name: "Brand Settings", path: "/admin/brand-settings/brand", requires: "BRAND_MANAGEMENT", group: "Product Config" },
					{ name: "Disclaimers", path: "/admin/disclaimers", requires: "DISCLAIMER", group: "Product Config" },
					{ name: "Email Templates", path: "/admin/company-email-templates", requires: "COMPANY_MANAGEMENT", group: "Admin" },
					{ name: "External Access", path: "/admin/external-access", requires: "EXTERNAL_ACCESS_MANAGEMENT", group: "Admin" },
					{ name: "Fund Management", path: "/admin/fund-management", requires: "FUNDS", group: "Product Config" },
					{ name: "Model Portfolios", path: "/admin/model-portfolio", requires: "MODEL_PORTFOLIOS", group: "Product Config" },
					{ name: "Portfolio Management", path: "/admin/portfolio-management", requires: "PORTFOLIO_MANAGEMENT", group: "Product Config" },
					{ name: "Roles and Permissions", path: "/admin/role-permissions", requires: "ROLES", group: "Admin" },
					{ name: "Sectors", path: "/admin/sectors", requires: "SECTORS", group: "Product Config" },
					{ name: "Templates", path: "/admin/templates", requires: "TEMPLATES", group: "Product Config" },
					{ name: "Tickers", path: "/admin/tickers", requires: "TICKERS", group: "Admin" },
					{ name: "User Management", path: "/admin/user-management", requires: "USER_MANAGEMENT", group: "Admin" },
				])
				setSideBarExtensionLeft(true)
				setSideBarRight(false)
				setSideBarExtensionRight('')
				setAlertBannerActive(false)
				setTopMessage(null);
			}
		}
		else if (path.includes("/analytics")) {
			const links = jsonFile.tabs.map(t => {
				return { name: t.name, path: ROUTE_PATHS[PAGES.ANALYTICS] + t.path }
			})
			setSideBarExtensionLeft(true)
			setTopBarExtContent({
				header: "Analytics",
				icon: <BarChart2 color="#0E8EFD" />,
				links: links
			})
			setSidebarExtLeftLinks([])
			setSidebarExtLeftHeader(null)
			setTopBarExtension(true)
			setSideBarExtensionLeft(false)
			setSideBarRight(false)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
			setTopMessage(null);
		}
		else if (path.includes("/crm") && !path.includes("delivery")) {
			setTopBarExtContent({
				header: "CRM",
				icon: <User color="#0E8EFD" />,
				links: [{ name: "Users", path: "/crm/users" }, { name: "Companies", path: "/crm/companies" }, { name: "Distribution Lists", path: "/crm/distribution" }, { name: "Suppressed Emails", path: "/crm/suppressions" }]
			})
			setSidebarExtLeftLinks([])
			setSidebarExtLeftHeader(null)
			setTopBarExtension(true)
			setSideBarExtensionLeft(false)
			setSideBarRight(false)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
			setTopMessage(null);
		}
		else if (path.includes("/crm")) {
			if (user && user.perms && user.perms.some((val) => ["USERS", "COMPANIES", "DISTRIBUTION", "SUPPRESSED_EMAILS"].includes(val))) {
				setSidebarExtLeftLinks([{ name: "Users", path: "/crm/users", requires: "USERS" },
				{ name: "Companies", path: "/crm/companies", requires: "COMPANIES" },
				{ name: "Distribution Lists", path: "/crm/distribution", requires: "DISTRIBUTION" },
				{ name: "Suppressed Emails", path: "/crm/suppressions", requires: "SUPPRESSED_EMAILS" }])
				setSideBarExtensionLeft(true)
				setSideBarRight(false)
				setSideBarExtensionRight('')
				setAlertBannerActive(false)
				setTopMessage(null);
			}
		}
		else if (path.includes("/settings") && !path.includes("/publication")) {
			setTopBarExtContent(null)
			// setSidebarExtLeftLinks([{ name: "Profile", path: "/settings/profile" }, { name: "Settings", path: "/settings/general" }])
			setSidebarExtLeftLinks([])
			setSidebarExtLeftHeader(null)
			setTopBarExtension(false)
			setSideBarExtensionLeft(false)
			setSideBarRight(false)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
			setTopMessage(null);
		}
		else if (path.includes("/publication")) {
			setTopBarExtContent(null)
			setSidebarExtLeftLinks([{ name: "Note View", path: `/publication/${pathArray[2]}` }, { name: "Note Settings", path: `/publication/${pathArray[2]}/settings` }])
			setSidebarExtLeftHeader(null)
			setTopBarExtension(false)
			setSideBarExtensionLeft(true)
			setSideBarRight(false)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
			setTopMessage(null);
		}
		else if (path.includes("/active-workflows")) {
			setTopBarExtContent({
				header: "Workflow Monitor",
				icon: <ActiveWorkFlowIcon colour="#0E8EFD" />,
				links: [{ name: 'Workflow Monitor', path: '/active-workflows' }],
				headerOnly: true
			})
			setSidebarExtLeftLinks([])
			setSidebarExtLeftHeader(null)
			setTopBarExtension(true)
			setSideBarExtensionLeft(false)
			setSideBarRight(false)
			setSideBarExtensionRight(false)
			setAlertBannerActive(false)
			setTopMessage(null);

		} else if (path.includes('/help')) {
			const videoLinks = (helpVideos || []).map(v => {
					return { name: v.title, path: ROUTE_PATHS[PAGES.HELP] + `/${v.uuid}`, group: "How To Guides" };
				});
			setTopBarExtContent(null)
			setSideBarExtensionLeft(true)
			setSidebarExtLeftHeader({ header: "Help", icon: <HelpCircle color="#0E8EFD" /> })
			setSidebarExtLeftLinks(videoLinks)
			setTopBarExtension(false)
			setSideBarRight(false)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
			setTopMessage(null);
		}
		else {
			setTopBarExtContent(null)
			setSidebarExtLeftLinks([])
			setSidebarExtLeftHeader(null)
			setTopBarExtension(false)
			setSideBarExtensionLeft(false)
			setSideBarRight(false)
			setSideBarExtensionRight('')
			setAlertBannerActive(false)
			setTopMessage(null);
		}
	}, [props.location.pathname, user, noPermissions, organisation, portfolioTopBarHierarchy])

	return (
		<div id="master-grid" className={`${sideBarExtensionLeft ? " grid-sidebar-ext-left-active " : ""}${sideBarRight ? " grid-sidebar-right-active " : ""}${sideBarExtensionRight.length > 0 ? " grid-sidebar-ext-right-active" : ""}${sideBarExtensionRight === 'm' ? ' right-m' : sideBarExtensionRight === 'l' ? ' right-l' : ""}${alertBannerActive ? " grid-alert-banner-active " : ""}${topBarExtension ? " grid-topbar-ext-active " : ""}`}>
			<TopBar switchingCompany={switchingCompany} setSwitchingCompany={setSwitchingCompany} topMessage={topMessage} sendMessage={sendMessage} isExternalManager={isExternalManager} />
			{!noPermissions && topBarExtContent && topBarExtContent.links && topBarExtContent.links.length > 0 && <TopBannerExtension header={topBarExtContent.header} icon={topBarExtContent.icon} links={topBarExtContent.links} headerOnly={topBarExtContent.headerOnly} location={location.pathname} />}
			<SideBarLeft header={sidebarExtLeftHeader} jsonFile={jsonFile} isExternalManager={isExternalManager} organisation={organisation} me={user} helpPage={helpPage} />
			{sidebarExtLeftLinks.length > 0 && <SidebarExtensionWrapper leftSideBarCollapsed={leftSideBarCollapsed} setLeftSideBarCollapsed={setLeftSideBarCollapsed} collapsable={width < 801} sideBarLeft links={sidebarExtLeftLinks} header={sidebarExtLeftHeader} organisation={organisation} me={user} helpPage={helpPage} />}
			{props.children}
			{switchingCompany &&
				<div className='loading-modal' style={{ left: 0, zIndex: 30 }}>
					<div className='loading-modal-inner'>
						<LoadingIcon variant='light' />
					</div>
				</div>
			}
		</div>
	)
};

export default withStorage(withRouter(MenuWrapper));